import { cn } from "@omni/utils/styles";
import { isEmpty } from "lodash-es";

import { DefaultFacetValueComponent } from "./defaultFacetValue.component";
import { ShowProductsFacetValues } from "./showProductsFacet.types";
import { StoreFacetValueComponent } from "./storeFacetValue.component";

type DefaultFacetComponentProps = {
    values: ShowProductsFacetValues;
};

const ShowProductsFacetComponent = ({ values }: DefaultFacetComponentProps) => {
    const hasStoreValue = !isEmpty(values.storeValues);
    const hasRefinedStoreValue = values.storeValues.some(
        ({ refined }) => refined
    );

    return (
        <ul className={cn("tw:pl-0 tw:mb-0")}>
            {hasStoreValue && hasRefinedStoreValue && (
                <StoreFacetValueComponent
                    key={`${hasStoreValue}-${hasRefinedStoreValue}`}
                />
            )}
            {values.defaultValues.map((value) => (
                <DefaultFacetValueComponent
                    key={`${value.label}-${value.refined}`}
                    value={value}
                />
            ))}
            {hasStoreValue && !hasRefinedStoreValue && (
                <StoreFacetValueComponent
                    key={`${hasStoreValue}-${hasRefinedStoreValue}`}
                />
            )}
        </ul>
    );
};

export { ShowProductsFacetComponent };
